export default __webpack_public_path__ + "static/cloudStrategy-6e203b6a6df39787e5133b31a0bb2fcf.svg";